import { useEffect, useState } from 'react';

const MODAL_SELECTOR = '.atlaskit-portal-container .atlaskit-portal [role=dialog]';
const isModalOnScreen = (): boolean => Boolean(globalThis.document?.querySelector(MODAL_SELECTOR));

export const useIsVisibleWhenNoModalOnScreen = (): boolean => {
	const [isVisible, setIsVisible] = useState(() => !isModalOnScreen());

	useEffect(() => {
		const body = globalThis.document?.body;
		if (!body) {
			return;
		}

		const updateVisibility = () => {
			setIsVisible((previousVisibility) => {
				const nextVisibility = !isModalOnScreen();
				return previousVisibility === nextVisibility ? previousVisibility : nextVisibility;
			});
		};

		// Sync once in case the DOM changed between initial render and effect setup.
		updateVisibility();

		const observer = new MutationObserver(() => {
			updateVisibility();
		});
		observer.observe(body, {
			childList: true,
			subtree: true,
		});

		return () => {
			observer.disconnect();
		};
	}, []);

	return isVisible;
};
